import app from 'flarum/forum/app';
import Page from 'flarum/forum/components/Page';
import Button from 'flarum/common/components/Button';
import icon from 'flarum/common/helpers/icon';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import ItemList from 'flarum/common/utils/ItemList';
import classList from 'flarum/common/utils/classList';
import extractText from 'flarum/common/utils/extractText';

import Checkbox from '../../common/widgets/Checkbox';
import Slider from '../../common/widgets/Slider';
import Select from '../../common/widgets/Select';
import Multiselect from '../../common/widgets/Multiselect';
import Keyselect from '../../common/widgets/Keyselect';
import Colorbox from '../../common/widgets/Colorbox';

export default class ApplicationConfigPage extends Page  {
    oninit(vnode) {
        super.oninit(vnode);

        app.history.push('application.configs.show', icon('fas fa-th'));

        app.preloadedApiDocument();
        app.setTitle(extractText(app.translator.trans('xtreh-phoenix.forum.applications.configs.label', { application: app.store.getBy('applications', 'slug', this.application_slug()).name() })) + (' - ' + app.store.getBy('application.configs', 'id', this.config_id()).name()));
        app.setTitleCount(0);

        //window.addEventListener("resize", () => m.redraw());
        //window.addEventListener("orientationchange", () => m.redraw());

        this.isLoadingPage = true;
        this.isSyncedConfigData = true;
        this.structure = {};
        this.config = null; // default config variables
        this.config_data = {}; // modified config variables, similar for list of changes of default config

        app.store.find('applications', this.application_slug(), { include: 'defaultConfig' }).then((application) => {
            this.structure = application.defaultConfig().structure();
            app.store.find('applications/configs', this.config_id(), { application: this.application_slug() }).then((config) => {
                this.config = config;
                this.config_data = config.config();
                this.parse_object(this.structure).map((object) => object.value = this.get_value_of_object(object));

                this.isLoadingPage = false;
                m.redraw();
            });
        });

        // callback that will save config ( send request ) if are there any changes of config
        setInterval(() => {
            if (!this.isSyncedConfigData) {
                this.config.save({ config: this.config_data });
                this.isSyncedConfigData = true;
            }
        }, 250);
    }

    view() {
        const variables = this.variables().toArray();

        const application = app.store.getBy('applications', 'slug', this.application_slug());

        const config = this.config;

        const title = app.translator.trans('xtreh-phoenix.forum.applications.configs.label', { application: application?.name() }).join(' ') + (config ? (' - ' + config.name()) : '');

        return (
            <div className='ApplicationConfigPage'>
                <div className='ApplicationConfigPage-header'>
                    <h4 className='App-titleControl App-titleControl--text'> {title}</h4>
                </div>
                {
                    this.isLoadingPage ? <LoadingIndicator size='large' /> : <section
                        className='ApplicationConfigPage-grid'
                        style={{ '--rows': variables.length }}
                        role="table"
                        aria-rowcount={variables.length}
                        aria-colcount={2}
                        aria-live="polite"
                        aria-busy={this.isLoadingPage ? 'true' : 'false'}
                        ontouchstart={(e) => {
                            this.startX = e.changedTouches[0].clientX;
                            this.startY = e.changedTouches[0].clientY;
                        }}
                        ontouchend={(e) => {
                            const swipe = (direction) => {
                                const tabs = this.parse_object(this.structure, 'tab');
                                const active_index = tabs?.findIndex((v) => v.value === true);
                                const direction_index = active_index + ((direction === 'right') ? 1 : -1);
                                // check that direction index is in tabs bounds
                                if (direction_index >= 0 && direction_index < tabs?.length) {
                                    tabs[active_index].value = false;
                                    m.redraw.sync();
                                    tabs[direction_index].value = true;
                                    m.redraw.sync();
                                }
                            }

                            const deltaX = e.changedTouches[0].clientX - this.startX;
                            const deltaY = e.changedTouches[0].clientY - this.startY;

                            if (Math.abs(deltaY) < 50) {
                                if (deltaX > 50) swipe('left');
                                else if (deltaX < -50) swipe('right');
                            }
                        }}
                    >
                        {/* Render variables data */}
                        {
                            variables.map((variable, rowIndex) => {
                                return [
                                    variable.widget && <div
                                        className={'ApplicationConfigPage-grid-variable ApplicationConfigPage-grid-variable-widget ApplicationConfigPage-grid-variable-widget-'+variable.type}
                                        data-row-name={`${variable.type}-${variable.slug}-control`}
                                        aria-colindex={1}
                                        aria-rowindex={rowIndex}
                                        role="cell"
                                    >
                                        <div className={'ApplicationConfigPage-grid-variable-widget-content'}>
                                            { variable.widget }
                                        </div>
                                    </div>,
                                    variable.description && <div
                                        className={'ApplicationConfigPage-grid-variable ApplicationConfigPage-grid-variable-description'}
                                        data-column-name={`${variable.type}-${variable.slug}-description`}
                                        aria-colindex={2}
                                        aria-rowindex={rowIndex}
                                        role="cell"
                                    >
                                        <div className='ApplicationConfigPage-grid-variable-description-content'>
                                            { variable.description }
                                        </div>
                                    </div>
                                ];
                            })
                        }
                    </section>
                }
            </div>
        );
    }

    variables()
    {
        const variables = new ItemList();

        const tabs_with_name = (this.parse_object(this.structure, 'tab').length <= 3 || $(window).outerWidth() >= 768);

        this.parse_object(this.structure, undefined, true).map((object, object_index) => {
            switch (object.type) {
                case 'tab': {
                    !variables.has('/config/tab') && variables.add(
                        '/config/tab',
                        {
                            type: object.type,
                            widget: (
                                <div className='ApplicationConfigPage-grid-variable-widget-tab'>
                                {
                                    this.parse_object(this.structure, 'tab', true).map((object, index, tabs) => {
                                        return (
                                            <span className={object.value ? 'ApplicationConfigPage-grid-variable-widget-tab-active' : ''} onclick={() => {
                                                if (tabs.every((tab) => {
                                                    if (object.path != tab.path) tab.value = false;
                                                    return !tab.value;
                                                })) {
                                                    // ensure the redraw happened immediately after disable all tabs,
                                                    // to force diff algorithm to update vnodes.
                                                    m.redraw.sync();
                                                    object.value = !object.value;
                                                    m.redraw.sync();
                                                }
                                            }}
                                            >
                                                {[ object.icon && icon(object.icon), tabs_with_name && [' ', object.slug] ]}
                                            </span>
                                        );
                                    })
                                }
                                </div>
                            )
                        }
                    );
                    break;
                }
                case 'label': {
                    variables.add(
                        object.path + `/${object_index}`,
                        {
                            type: object.type,
                            widget: <span>{app.translator.trans(object.desc, ...object)}</span>
                        }
                    );
                    break;
                }
                case 'checkbox': {
                    variables.add(
                        object.path,
                        {
                            type: object.type,
                            widget: [
                                object.name && <p>{object.name}</p>,
                                <Checkbox state={object.value} onchange={(value) => this.sync_value_of_object(object, value) }>{app.translator.trans(object.value ? 'xtreh-phoenix.forum.config.checkbox_active' : 'xtreh-phoenix.forum.config.checkbox_nonactive')}</Checkbox>,
                            ],
                            description: [
                                object.desc && <span>{app.translator.trans(object.desc, ...object)}</span>,
                                object.note && <div className='ApplicationConfigPage-grid-variable-description-content-note'>{app.translator.trans(object.note, ...object)}</div>
                            ]
                        }
                    );
                    break;
                }
                case 'slider': {
                    variables.add(
                        object.path,
                        {
                            type: object.type,
                            widget: [
                                object.name && <p>{object.name}</p>,
                                <Slider min={object.min} max={object.max} value={object.value} onchange={(value) => this.sync_value_of_object(object, value) }>{object.slug}</Slider>,
                            ],
                            description: [
                                object.desc && <span>{app.translator.trans(object.desc, ...object)}</span>,
                                object.note && <div className='ApplicationConfigPage-grid-variable-description-content-note'>{app.translator.trans(object.note, ...object)}</div>
                            ]
                        }
                    );
                    break;
                }
                case 'select': {
                    variables.add(
                        object.path,
                        {
                            type: object.type,
                            widget: [
                                object.name && <p>{object.name}</p>,
                                <Select className='SelectDropdown' buttonClassName='Button SelectDropdown-Button' label={object.value}>{object.options.map((option) => <Button onclick={this.sync_value_of_object.bind(this, object, option)}>{option}</Button>)}</Select>,
                            ],
                            description: [
                                object.desc && <span>{app.translator.trans(object.desc, ...object)}</span>,
                                object.note && <div className='ApplicationConfigPage-grid-variable-description-content-note'>{app.translator.trans(object.note, ...object)}</div>
                            ]
                        }
                    );
                    break;
                }
                case 'multiselect': {
                    variables.add(
                        object.path,
                        {
                            type: object.type,
                            widget: [
                                object.name && <p>{object.name}</p>,
                                <Multiselect className='MultiselectDropdown' buttonClassName='Button MultiselectDropdown-Button' value={object.value}>
                                    {
                                        object.options.map((option) =>
                                            <Button onclick={(event) => {
                                                if (event.shiftKey) event.stopPropagation();

                                                let value = object.value;
                                                if (!value.includes(option))
                                                    value.push(option);
                                                else
                                                    value.splice(value.indexOf(option), 1);

                                                this.sync_value_of_object(object, value);
                                            }}
                                            >
                                                {option}
                                            </Button>)
                                    }
                                </Multiselect>,
                            ],
                            description: [
                                object.desc && <span>{app.translator.trans(object.desc, ...object)}</span>,
                                object.note && <div className='ApplicationConfigPage-grid-variable-description-content-note'>{app.translator.trans(object.note, ...object)}</div>
                            ]
                        }
                    );
                    break;
                }
                case 'keyselect': {
                    variables.add(
                        object.path,
                        {
                            type: object.type,
                            widget: [
                                object.name && <p>{object.name}</p>,
                                <Keyselect className='KeyselectDropdown' buttonClassName='Button KeyselectDropdown-Button' menuClassName='KeyselectDropdown-DropdownMenu' keyid={object.value} onchange={(value) => this.sync_value_of_object(object, value)}/>,
                            ],
                            description: [
                                object.desc && <span>{app.translator.trans(object.desc, ...object)}</span>,
                                object.note && <div className='ApplicationConfigPage-grid-variable-description-content-note'>{app.translator.trans(object.note, ...object)}</div>
                            ]
                        }
                    );
                    break;
                }
                case 'colorbox': {
                    variables.add(
                        object.path,
                        {
                            type: object.type,
                            widget: [
                                object.name && <p>{object.name}</p>,
                                <Colorbox value={object.value} onchange={(value) => this.sync_value_of_object(object, value)}></Colorbox>,
                            ],
                            description: [
                                object.desc && <span>{app.translator.trans(object.desc, ...object)}</span>,
                                object.note && <div className='ApplicationConfigPage-grid-variable-description-content-note'>{app.translator.trans(object.note, ...object)}</div>
                            ]
                        }
                    );
                    break;
                }
            }
        });

        return variables;
    }

    parse_object(object, type = undefined, value = undefined) {
        let array = [];
        function parse_recursive(object, path) {
            // all objects should have slug attribute
            if (jQuery.isEmptyObject(object) === false && object.slug === undefined) {
                //throw (`Config object [${path}] should have slug attribute!`);
                return;
            }
            // get full path of the object
            path +=  '/' + object.slug;
            // compare type with object
            if (type === undefined || object?.type === type) {
                // set path of the object
                object.path = path;
                // insert object into array
                array.push(object);
            }
            // compare value with object
            if (value === undefined || object?.value === value) {
                // iterate over childrens if they are exist
                object?.childrens?.map((children) => parse_recursive(children, path));
            }
        }

        // recursive iterate over objects and collect only actives and target types
        parse_recursive(object, '');

        return array;
    }

    get_value_of_object(object) {
        const config_object = object.path.replace(/^\W/, '').split('/').reduce((prev, curr) => prev && prev[curr] || null, this.config_data);
        return (config_object && ('value' in config_object)) ? config_object.value : object.value;
    }

    set_value_of_object(object, value) {
        object.value = value;
        object.path.replace(/^\W/, '').split('/').reduce((prev, curr, idx, arr) => {
            if (!(curr in prev)) prev[curr] = {};
            if (idx === arr.length - 1) prev[curr].value = value;
            return prev[curr];
        }, this.config_data);
    }

    sync_value_of_object(object, value) {
        this.set_value_of_object(object, value);
        this.isSyncedConfigData = false;
    }

    application_slug() {
        return m.route.param('application');
    }

    config_id() {
        return m.route.param('config');
    }
}
